import { Page as Base } from "@cancer-council-queensland/react";
import { renderStoryblokComponents } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
export var Page = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Base, {
    children: renderStoryblokComponents(children)
  });
};
//# sourceMappingURL=page.js.map